import $ from 'jquery';

export default {
	init() {
		console.log('Nylon Thought Leadership Template');

		$('a[href*="#thought-leadership-popup"]').on('click', function () {
			$('[data-popup="thought-leadership"]').fadeIn('200');

			// if doesn't match exactly, check for a word at the end to pre-check an option
			if ($(this).prop('href') != '#thought-leadership-popup') {
				// get last part of link string
				let thisLink = $(this).prop('href').split('-').pop(),
					thisLinkCap =
						thisLink.substr(0, 1).toUpperCase() + thisLink.substr(1),
					$thisOption = null;

				// if has a pre-check word
				if (thisLink) {
					// find its option in the form
					$thisOption = $(
						'[data-popup="thought-leadership"] .hs-form-checkbox input[value="' +
							thisLink +
							'"]'
					);
					// if can't find it, try the capitalized version
					if (!$thisOption.length) {
						$thisOption = $(
							'[data-popup="thought-leadership"] .hs-form-checkbox input[value="' +
								thisLinkCap +
								'"]'
						);
					}
				}

				// if an option in the form matches the pre-check string
				if ($thisOption.length) {
					// click that option (hubspot requires a click on the parent <label> to register the click)
					$thisOption.parents('label').click();
				}
			}
		});

		$('[data-popup="thought-leadership"] .close').on('click', function () {
			$(this).parents('[data-popup="thought-leadership"]').fadeOut('200');
		});
	},
	finalize() {},
};
